import { getToken } from "@/utils/auth";
import service from "@/utils/request";


export const getAllRequests = async (page) => {
    try{
        const response = await service.get('/contactus?page='+page);
        return response;
    }catch(e){
        console.error("Failed to fetch requests:", e);
    }
}

export const requestSearch = async (data) => {
    try{
        const response = await service.get('/contactus-search?page='+data.page+'&value='+data.value);
        return response;
    }catch(e){
        console.error("Failed to fetch requests:", e);
    }
}

export const addRequest = async (request) => {
    try{
        const response = await service.post('/contactus',request);
        return response;
    }catch(e){
        throw new Error(e);
    }
}

export const destroyRequest = async (id) => {
    try{
        
        const response = await service.delete('/contactus/'+id);
        return response;

    }catch(e){
        throw new Error(e);
    }
}